import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { FormArray, FormGroup } from "@angular/forms";
import LocalizationConstants from "src/app/constants/localization-constants";
import CustomerSettings from "src/app/models/CustomerSettings";
import { UnitOfMeasure } from "src/app/models/Enums";
import {
  ParcelDimensionsOption,
  ParcelDimensionsOptionsByUnitOfMeasure,
  ParcelDimensionsOptionType,
  ParcelOption,
  ParcelOptionsWithLabels,
} from "src/app/models/ParcelDimensionsOption";
import { FormKeys } from "src/app/models/ServiceRequest";
import { getUnitTranslations } from "src/app/utils/measures.utils";
import { originalOrderFn } from "src/app/utils/object.utils";
import { getDimensionsLabel } from "src/app/utils/parcels.utils";

@Component({
  selector: "app-shipping-packages-request-form",
  templateUrl: "./shipping-packages-request-form.component.html",
  styleUrl: "./shipping-packages-request-form.component.scss",
  standalone: false,
})
export class ShippingPackagesRequestFormComponent implements OnInit {
  localizationConstants = LocalizationConstants;
  unitOfMeasure = UnitOfMeasure;
  @Output() addPackageEvent: EventEmitter<void> = new EventEmitter<void>();
  @Output() removePackageEvent: EventEmitter<number> = new EventEmitter<number>();
  @Output() copyPackageEvent: EventEmitter<ParcelOption> = new EventEmitter<ParcelOption>();
  @Input() formArray: FormArray<FormGroup>;
  @Input() customerSettings: CustomerSettings;

  lengthUnitTranslation: string;
  weightUnitTranslation: string;
  parcelOptionsWithLabels = ParcelOptionsWithLabels;
  parcelDimensionOptions: Record<ParcelDimensionsOptionType, ParcelDimensionsOption>;
  formKeys = FormKeys;

  getDimensionsLabel = getDimensionsLabel;

  ngOnInit() {
    this.setUnitTranslations();
    this.setParcelDimensionOptions();
  }

  setUnitTranslations() {
    const unitTranslations = getUnitTranslations(this.customerSettings.unitOfMeasure);
    this.lengthUnitTranslation = unitTranslations.lengthUnitTranslation;
    this.weightUnitTranslation = unitTranslations.weightUnitTranslation;
  }

  setParcelDimensionOptions() {
    this.parcelDimensionOptions =
      ParcelDimensionsOptionsByUnitOfMeasure[this.customerSettings.unitOfMeasure];
  }

  originalOrder = originalOrderFn;

  addPackage() {
    this.addPackageEvent.emit();
  }

  removePackage(index: number) {
    this.removePackageEvent.emit(index);
  }

  copyPackage(parcel: ParcelOption) {
    this.copyPackageEvent.emit(parcel);
  }
}
